// Payload names stay distinct; all output configuration and overrides share
// the product's Multi IO permission. Legacy grants must not widen it.
export const multiIOCategories = ['multi_io', 'multi_out', 'overwr_io', 'user_func_sets'];

export const permissionCategory = (category) =>
  multiIOCategories.includes(category) || ['multi_in_out', 'overwr_in_out', 'outputs'].includes(category)
    ? 'multi_io'
    : category;

export function groupedAccessRights(rights = {}) {
  const access = rights.multi_io ?? { read: false, write: false };
  return { ...rights, multi_out: access, overwr_io: access };
}
